import { PairLayout } from 'components/explorer/pairs/PairLayout';

export const ExplorerPairs = () => {
  return <PairLayout url="/explore/pairs" />;
};
